import api from "./api";

const deviceAuthorizationService = {
  getPending: (params) => api.get("/device-authorization/pending", { params }),
  getDevices: (params) => api.get("/device-authorization/devices", { params }),
  approve: (id) => api.post(`/device-authorization/${id}/approve`),
  reject: (id, body) => api.post(`/device-authorization/${id}/reject`, body || {}),
  revoke: (id) => api.post(`/device-authorization/${id}/revoke`),
};

export default deviceAuthorizationService;
